import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SpacerIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Spacer",
    children: /*#__PURE__*/_jsx("path", {
      d: "M30.39 26.99h-2.78c-.88 0-1.59-.71-1.59-1.59s.71-1.59 1.59-1.59h1.21v-1.06c.07-.83.75-1.47 1.59-1.47s1.52.65 1.59 1.47v2.65c0 .88-.71 1.59-1.59 1.59h-.01Zm-7.69 0h-4.32c-.88 0-1.59-.71-1.59-1.59s.71-1.59 1.59-1.59h4.33c.83.07 1.47.75 1.47 1.59s-.65 1.52-1.47 1.59Zm-9.23 0H9.15c-.88 0-1.59-.71-1.59-1.59s.71-1.59 1.59-1.59h4.33c.83.07 1.47.75 1.47 1.59s-.65 1.52-1.47 1.59Zm-9.22 0H1.59C.71 26.99 0 26.28 0 25.4v-2.65c.07-.83.75-1.47 1.59-1.47s1.52.65 1.59 1.47v1.07h1.19c.88 0 1.59.71 1.59 1.59S5.25 27 4.37 27h-.13Zm-2.66-7.41c-.88 0-1.59-.71-1.59-1.59v-3.97c.07-.83.75-1.47 1.59-1.47s1.52.65 1.59 1.47v3.97c0 .88-.71 1.59-1.58 1.59Zm0-8.73c-.88 0-1.58-.72-1.58-1.59H0V6.6c0-.88.71-1.59 1.58-1.59h2.66c.83.07 1.47.75 1.47 1.59s-.65 1.52-1.47 1.59H3.15v1.07c0 .87-.7 1.58-1.57 1.59ZM22.7 8.19h-4.2c-.83-.07-1.47-.75-1.47-1.59s.65-1.52 1.47-1.59h4.2c.83.07 1.47.75 1.47 1.59s-.65 1.52-1.47 1.59m-9.22 0h-4.2c-.88 0-1.59-.71-1.59-1.59s.71-1.59 1.59-1.59h4.2c.83.07 1.47.75 1.47 1.59s-.65 1.52-1.47 1.59m16.91 2.66c-.87-.01-1.58-.72-1.58-1.59V8.2h-1.08c-.83-.07-1.47-.75-1.47-1.59s.65-1.52 1.47-1.59h2.65c.88 0 1.59.71 1.59 1.59v2.65c0 .88-.71 1.59-1.58 1.59m0 8.73c-.87-.01-1.58-.72-1.58-1.59V13.9c0-.88.71-1.59 1.59-1.59s1.59.71 1.59 1.59v4.09c0 .88-.71 1.59-1.59 1.59z"
    })
  }));
};